/**
 * Detector de m�dia no frontend - vers�o simplificada do backend
 */

export const isYouTubeShort = (url) => {
  if (!url) return false;
  return url.includes('youtube.com/shorts/') || url.includes('youtu.be/shorts/');
};

export const isInstagramReel = (url) => {
  if (!url) return false;
  return url.includes('instagram.com/reel/');
};

export const isInstagramStory = (url) => {
  if (!url) return false;
  return url.includes('instagram.com/stories/');
};

export const isFacebookStory = (url) => {
  if (!url) return false;
  return (url.includes('facebook.com') || url.includes('fb.com')) && url.includes('/stories/');
};

export const isFacebookReel = (url) => {
  if (!url) return false;
  const lowerUrl = url.toLowerCase();
  return (lowerUrl.includes('facebook.com') || lowerUrl.includes('fb.com')) && (lowerUrl.includes('/reels/') || lowerUrl.includes('/reel/'));
};

export const isFacebookVideo = (url) => {
  if (!url) return false;
  const lowerUrl = url.toLowerCase();
  return (lowerUrl.includes('facebook.com') || lowerUrl.includes('fb.com')) && (lowerUrl.includes('/videos/') || lowerUrl.includes('/watch/'));
};

export const isPinterestPin = (url) => {
  if (!url) return false;
  return url.includes('pinterest.com/pin/') || url.includes('pin.it');
};

export const isThreadsPost = (url) => {
  if (!url) return false;
  return url.includes('threads.net/') || url.includes('threads.com/');
};

export const isVerticalContent = (article) => {
  const url = article?.siteUrl || article?.videoUrl || '';
  const contentType = article?.contentType || '';

  return contentType === 'short' ||
    contentType === 'reel' ||
    contentType === 'story' ||
    isYouTubeShort(url) ||
    isInstagramReel(url) ||
    isInstagramStory(url) ||
    isFacebookStory(url) ||
    isFacebookReel(url);
};

/**
 * Retorna dimensões recomendadas baseado no artigo
 */
export const getVideoDimensions = (article) => {
  const contentType = article?.contentType || '';
  const mediaType = article?.mediaType || '';

  // Instagram Reels - Sempre vertical 9:16
  if (contentType === 'reel' && mediaType === 'Instagram') {
    return {
      width: '100%',
      maxWidth: '360px',
      height: 'auto',
      aspectRatio: '9/16',
      margin: '0 auto',
      objectFit: 'contain'
    };
  }

  // YouTube Shorts - Sempre vertical 9:16
  if (contentType === 'short' && mediaType === 'YouTube') {
    return {
      width: '100%',
      maxWidth: '360px',
      height: 'auto',
      aspectRatio: '9/16',
      margin: '0 auto',
      objectFit: 'contain'
    };
  }

  // Instagram/Facebook Stories - Sempre vertical 9:16
  if (contentType === 'story') {
    return {
      width: '100%',
      maxWidth: '360px',
      height: 'auto',
      aspectRatio: '9/16',
      margin: '0 auto',
      objectFit: 'contain'
    };
  }

  // Conteúdo vertical (reels/shorts/stories detectados por URL)
  if (isVerticalContent(article)) {
    return {
      width: '100%',
      maxWidth: '360px',
      height: 'auto',
      aspectRatio: '9/16',
      margin: '0 auto',
      objectFit: 'contain'
    };
  }

  // Twitter Videos - Limitado a 550px
  if ((contentType === 'video' || contentType === 'tweet') && mediaType === 'Twitter') {
    return {
      width: '100%',
      maxWidth: '550px',
      height: 'auto',
      margin: '0 auto',
      objectFit: 'contain'
    };
  }

  // YouTube Videos normais - Responsivo 16:9
  if (contentType === 'video' && mediaType === 'YouTube') {
    return {
      width: '100%',
      maxWidth: '100%',
      height: 'auto',
      aspectRatio: '16/9',
      objectFit: 'contain'
    };
  }

  // Facebook Videos normais - Responsivo 16:9
  if (mediaType === 'Facebook' && (contentType === 'video' || isFacebookVideo(article?.siteUrl))) {
    return {
      width: '100%',
      maxWidth: '100%',
      height: 'auto',
      aspectRatio: '16/9',
      objectFit: 'contain'
    };
  }

  // Online Videos - Responsivo 16:9
  if (contentType === 'video' && mediaType === 'Online') {
    return {
      width: '100%',
      maxWidth: '100%',
      height: 'auto',
      aspectRatio: '16/9',
      objectFit: 'contain'
    };
  }

  // Pinterest Videos/Pins - vertical (2:3)
  if (mediaType === 'Pinterest') {
    return {
      width: '100%',
      maxWidth: '400px',
      height: 'auto',
      aspectRatio: '2/3',
      margin: '0 auto',
      objectFit: 'contain'
    };
  }

  // Upload de vídeo - usa dimensões baseadas na classificação dada
  if (contentType === 'upload') {
    // Se foi classificado como reel, usar dimensões verticais
    if (mediaType === 'Instagram' || mediaType === 'Facebook') {
      return {
        width: '100%',
        maxWidth: '360px',
        height: 'auto',
        aspectRatio: '9/16',
        margin: '0 auto',
        objectFit: 'contain'
      };
    }
    // Se foi classificado como short, usar dimensões verticais
    if (mediaType === 'YouTube') {
      return {
        width: '100%',
        maxWidth: '360px',
        height: 'auto',
        aspectRatio: '9/16',
        margin: '0 auto',
        objectFit: 'contain'
      };
    }
    // Default para uploads: responsivo 16:9
    return {
      width: '100%',
      maxWidth: '100%',
      height: 'auto',
      aspectRatio: '16/9',
      objectFit: 'contain'
    };
  }

  // Fallback para casos não mapeados
  return {
    width: '100%',
    maxWidth: '100%',
    height: 'auto',
    aspectRatio: '16/9',
    objectFit: 'contain'
  };
};

/**
 * Retorna o label amig�vel para o contentType
 */
export const getContentTypeLabel = (contentType) => {
  const labels = {
    short: 'Short',
    reel: 'Reel',
    story: 'Story',
    video: 'Vídeo',
    post: 'Post',
    tweet: 'Tweet',
    article: 'Artigo',
    upload: 'Upload',
    pin: 'Pin'
  };
  return labels[contentType] || contentType;
};

/**
 * Retorna o label amig�vel para o mediaType
 */
export const getMediaTypeLabel = (mediaType) => {
  const labels = {
    YouTube: 'YouTube',
    Twitter: 'Twitter',
    Instagram: 'Instagram',
    Pinterest: 'Pinterest',
    Online: 'Online'
  };
  return labels[mediaType] || mediaType;
};

/**
 * Retorna dimensões recomendadas baseado no artigo para imagens/posts
 * Estratégia: Dimensões específicas por plataforma para consistência visual
 */
export const getImageDimensions = (article) => {
  const contentType = article?.contentType || '';
  const mediaType = article?.mediaType || '';

  // Instagram Posts - Sempre quadrado (1:1) para consistência com a plataforma
  if (contentType === 'post' && mediaType === 'Instagram') {
    return {
      width: '100%',
      maxWidth: '600px',
      height: 'auto',
      aspectRatio: '1/1',
      margin: '0 auto',
      objectFit: 'contain'
    };
  }

  // Twitter Posts/Tweets - Limitado a 550px para consistência com embeds
  if (contentType === 'tweet' && mediaType === 'Twitter') {
    return {
      width: '100%',
      maxWidth: '550px',
      height: 'auto',
      aspectRatio: 'auto',
      margin: '0 auto',
      objectFit: 'contain'
    };
  }

  // Upload classificado como Instagram post - usar dimensões do Instagram
  if (contentType === 'upload' && mediaType === 'Instagram') {
    return {
      width: '100%',
      maxWidth: '600px',
      height: 'auto',
      aspectRatio: '1/1',
      margin: '0 auto',
      objectFit: 'contain'
    };
  }

  // Upload classificado como Twitter post - usar dimensões do Twitter
  if (contentType === 'upload' && mediaType === 'Twitter') {
    return {
      width: '100%',
      maxWidth: '550px',
      height: 'auto',
      aspectRatio: 'auto',
      margin: '0 auto',
      objectFit: 'contain'
    };
  }

  // Instagram genérico (fallback se contentType não for 'post')
  // Garante que TODAS as imagens do Instagram usem 600px
  if (mediaType === 'Instagram') {
    return {
      width: '100%',
      maxWidth: '600px',
      height: 'auto',
      aspectRatio: '1/1',
      margin: '0 auto',
      objectFit: 'contain'
    };
  }

  // YouTube Thumbnails - usar dimensões de vídeo 16:9
  if (mediaType === 'YouTube') {
    return {
      width: '100%',
      maxWidth: '480px',
      height: 'auto',
      aspectRatio: '16/9',
      margin: '0 auto',
      objectFit: 'contain'
    };
  }

  // TikTok - vídeos verticais (9:16) com largura limitada
  if (mediaType === 'TikTok') {
    return {
      width: '100%',
      maxWidth: '325px', // Largura padrão do embed TikTok
      height: 'auto',
      aspectRatio: '9/16',
      margin: '0 auto',
      objectFit: 'contain'
    };
  }

  // LinkedIn Posts - largura padrão do feed (552px), aspect ratio flexível
  // LinkedIn aceita 1.91:1 (1200x627), 1:1 (quadrado) e 1:1.25 (vertical)
  if (mediaType === 'LinkedIn') {
    return {
      width: '100%',
      maxWidth: '552px', // Largura padrão do feed LinkedIn
      height: 'auto',
      aspectRatio: 'auto', // Mantém proporção original
      margin: '0 auto',
      objectFit: 'contain'
    };
  }

  // Pinterest - pins geralmente são verticais (2:3)
  if (mediaType === 'Pinterest') {
    return {
      width: '100%',
      maxWidth: '400px',
      height: 'auto',
      aspectRatio: '2/3', // Proporção típica de pins
      margin: '0 auto',
      objectFit: 'contain'
    };
  }

  // Threads - posts quadrados como Instagram (1:1)
  if (mediaType === 'Threads') {
    return {
      width: '100%',
      maxWidth: '650px',
      height: 'auto',
      aspectRatio: '1/1',
      margin: '0 auto',
      objectFit: 'contain'
    };
  }

  // Artigos Online - responsivo sem restrições específicas
  if (contentType === 'article' && mediaType === 'Online') {
    return {
      width: '100%',
      maxWidth: '800px',
      height: 'auto',
      aspectRatio: 'auto',
      margin: '0 auto',
      objectFit: 'contain'
    };
  }

  // Fallback para casos não específicos - largura responsiva
  return {
    width: '100%',
    maxWidth: '100%',
    height: 'auto',
    aspectRatio: 'auto',
    margin: '0 auto',
    objectFit: 'contain'
  };
};
